<template>
  <div>
    <header-component />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <!-- VideoPlayer component in modal -->
  <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <VideoPlayer
        :videoSrc="`/${selectedVideo?.videoPath}/${selectedVideo?.videoName}`"
        :contentsId="contentsData.contentsId"
        screenName="CarouselScreen"
      />
      <button class="close-button" @click="closeModal">×</button>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <div class="com_tranomaki_title1">
      <h1>
        <img
          src="@/assets/common/img/bana-toranomaki.png"
          alt="営業「虎の巻」"
        />
      </h1>
      <div class="progress1">
        <ol>
          <li
            v-for="(phase, index) in skilupKouseiData?.skilupPhaseList"
            :key="phase.phaseId"
          >
            <span class="num1">{{ index + 1 }}</span
            ><a :href="'#step' + (index + 1)" class="txt1">{{
              phase.phaseName
            }}</a>
          </li>
        </ol>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <div class="com_toranomaki_content1">
          <div class="content1">
            <div
              v-for="(phase, index) in skilupKouseiData?.skilupPhaseList"
              :key="phase.phaseId"
            >
              <div class="hd1">
                <span class="anchor1" :id="'step' + (index + 1)"></span>
                <div>
                  <div class="step1 roboto">
                    <span class="t1">STEP</span>
                    <span class="t2">{{ index + 1 }}</span>
                  </div>
                  <h2>{{ phase.phaseName }}</h2>
                  <p>
                    {{ phase.phaseTitle }}
                  </p>
                </div>
                <div>
                  <span class="rate1"
                    ><img
                      src="@/assets/common/img/icon-t-check-s1.png"
                      alt=""
                    />進捗率</span
                  >
                  <span class="num1 roboto"
                    ><span class="t1">{{ getWatchedCount(phase) }}</span
                    ><span class="t2">/ </span
                    ><span class="t3">{{
                      phase.phaseKouseiList.length
                    }}</span></span
                  >
                </div>
              </div>
              <div class="body1">
                <div class="com_more_item1">
                  <div
                    class="item1"
                    v-for="chapter in getDisplayedChapters(
                      phase.phaseKouseiList,
                      phase.isOpen
                    )"
                    :key="chapter.chapterId"
                    :class="[
                      'item1',
                      {
                        active1:
                          activeChapter?.phaseId === chapter.phaseId &&
                          activeChapter?.chapterId === chapter.chapterId,
                      },
                    ]"
                    @click="
                      showActiveChapter(phase, chapter, 'STEP' + (index + 1))
                    "
                  >
                    <div>
                      <img
                        :src="
                          getCheckeImg(
                            activeChapter?.phaseId ?? '',
                            activeChapter?.chapterId ?? '',
                            chapter.phaseId,
                            chapter.chapterId,
                            chapter.isWatched
                          )
                        "
                        alt=""
                      />
                    </div>
                    <div>
                      <p class="copy1 roboto">{{ chapter.chapterName }}</p>
                      <p class="copy2">
                        <span>{{ chapter.chapterTitle }}</span>
                        {{ chapter.chapterComment }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="phase.phaseKouseiList.length > defaultDispCnt"
                    :class="{ open1: phase.isOpen }"
                  >
                    <span class="more_button1" @click="togglePhaseOpen(phase)"
                      ><span>もっと見る</span></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              iContentsDataFetched &&
              activeChapter?.chapterId &&
              contentsData.contentsId
            "
            class="content2 sticky-pane"
          >
            <div class="wrap1">
              <div class="cnt1">
                <div class="hd1">
                  <p class="roboto">{{ activeStepName }}</p>
                  <h2>{{ activePhaseName }}</h2>
                </div>
                <div class="hd2">
                  <div>
                    <p class="roboto">{{ activeChapter?.chapterName }}</p>
                    <h2>{{ activeChapter?.chapterTitle }}</h2>
                  </div>
                  <div>
                    <div class="com_check_comp1">
                      <input
                        type="checkbox"
                        id="checkComplete"
                        name=""
                        :value="activeChapter?.isWatched"
                        @change="updateWatchedStatus(activeChapter)"
                        :checked="activeChapter?.isWatched"
                      />
                      <label for="checkComplete">完了</label>
                    </div>
                  </div>
                </div>
                <div
                  v-if="contentsData.contentsVideoList.length > 0"
                  class="com_slider1"
                >
                  <carousel
                    class="slide"
                    :autoplay="0"
                    :pauseAutoplayOnHover="true"
                    :itemsToShow="itemsToShow"
                    :wrapAround="true"
                    :transition="500"
                  >
                    <slide
                      v-for="contentVideo in contentsData.contentsVideoList"
                      :key="contentVideo.rowNo"
                    >
                      <div class="item1">
                        <a href="#" class="movie1">
                          <img
                            v-if="contentVideo.thumbnail"
                            :src="contentVideo.thumbnail"
                            :alt="contentVideo.videoExp"
                            @click.prevent="openModal(contentVideo)"
                          />
                        </a>
                      </div>
                    </slide>
                    <template #addons>
                      <navigation />
                      <pagination />
                    </template>
                  </carousel>
                </div>
                <div class="body1">
                  <div
                    v-if="contentsData.contentsImgList.length > 0"
                    class="com_d_content1"
                  >
                    <img
                      :src="`/${contentsData.contentsImgList[0].imgPath}/${contentsData.contentsImgList[0].imgName}`"
                      :alt="contentsData.contentsImgList[0].imgExp"
                    />
                  </div>
                  <div class="ql-editor" v-html="sanitizedContent"></div>
                  <div v-if="contentsData.contentsTempFileList.length > 0">
                    <h3>関連資料</h3>
                    <ul class="list1">
                      <li
                        v-for="tempFile in contentsData?.contentsTempFileList"
                        :key="tempFile.rowNo"
                      >
                        <a
                          :href="`/${tempFile.tempFilePath}/${tempFile.tempFileName}`"
                          class="com_link1"
                          target="_blank"
                          @click="regFileLinkClick(tempFile.tempFileName)"
                          >{{ tempFile.tempFileName }}</a
                        ><a
                          href="#"
                          class="com_dl_button2"
                          @click.prevent="
                            downloadFiles(
                              contentsData.categoryId,
                              contentsData.contentsId,
                              tempFile.tempFileName
                            )
                          "
                          ><span>ダウンロード</span></a
                        >
                      </li>
                    </ul>
                  </div>
                  <div v-if="contentsData.contentsLinkList.length > 0">
                    <h3>関連リンク</h3>
                    <ul class="list1">
                      <li
                        v-for="contentsLink in contentsData?.contentsLinkList"
                        :key="contentsLink.rowNo"
                      >
                        <a
                          :href="contentsLink.url"
                          class="com_link1"
                          target="_blank"
                          @click="regLinkClick(contentsLink.url)"
                          rel="noopener noreferrer"
                          >{{ contentsLink.caption }}</a
                        >
                      </li>
                    </ul>
                  </div>
                  <router-link
                    :to="`/${contentsData.detailPath}/categoryId/${
                      contentsData.categoryId
                    }/contentsId/${contentsData.contentsId}/ismodal/${true}`"
                    class="button1"
                    target="_blank"
                    @click="
                      regLinkClick(
                        `/${contentsData.detailPath}/categoryId/${
                          contentsData.categoryId
                        }/contentsId/${contentsData.contentsId}/ismodal/${true}`
                      )
                    "
                    >詳細はこちら</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 文言エリア-->
          <div v-else class="content2">
            <div
              v-if="
                skilupKouseiData &&
                skilupKouseiData.skilupCommentList.length > 0
              "
              class="wrap1"
            >
              <div class="cnt1">
                <div class="hd1">&nbsp;</div>
                <div class="body1">
                  <p
                    v-for="(
                      comment, index
                    ) in skilupKouseiData?.skilupCommentList"
                    :key="index"
                  >
                    {{ comment }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div v-if="isDataFetched">
    <!-- フッタ -->
    <FooterComponent />
  </div>

  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  getTargetDate,
  sanitizeInput,
  isTokenAlive,
  scrollToTop,
  regLinkClickLog,
  regFileLinkClickLog,
  commonHandleAxiosError,
  formatMessage,
} from "@/Common";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import { AppConstants } from "@/constants/AppConstants";
import BackToTop from "../controls/BackToTop.vue";
import { useProcessingStore } from "../../store/useProcessingStore";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import IconCheck1w from "@/assets/common/img/icon-t-check1w.png";
import IconCheck1gr from "@/assets/common/img/icon-t-check1gr.png";
import IconCheck1g from "@/assets/common/img/icon-t-check1g.png";
import VideoPlayer from "../controls/VideoPlayer.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import apiDownloadClient from "@/util/apiClientDownload";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

/** スキルアップ構成 */
interface SkilupKouseiItem {
  dispCount: number;
  skilupPhaseList: SkilupPhaseListItem[];
  skilupCommentList: string[];
}

/**スキルアップフェーズリスト */
interface SkilupPhaseListItem {
  phaseId: string;
  phaseName: string;
  phaseTitle: string;
  phaseKouseiList: PhaseKouseiModel[];
  isOpen: boolean;
}

/** フェーズ構成 */
interface PhaseKouseiModel {
  phaseId: string;
  chapterId: string;
  chapterName: string;
  chapterTitle: string;
  chapterComment: string;
  chapterCategoryId: string;
  chapterContentsId: string;
  isWatched: boolean;
}

/** コンテンツリンク情報リスト */
interface ContentsLinkListModel {
  rowNo: number;
  caption: string;
  url: string;
}

/** コンテンツ動画情報リスト */
interface ContentsVideoListModel {
  rowNo: number;
  videoExp: string;
  videoPath: string;
  videoName: string;
  thumbnail: string;
}

/** コンテンツ添付情報リスト */
interface ContentsTempFileListModel {
  rowNo: number;
  tempFileExp: string;
  tempFilePath: string;
  tempFileName: string;
  tempFileSize: string;
}

/** コンテンツ画像情報リスト */
interface ContentsImgListModel {
  rowNo: number;
  imgExp: string;
  imgPath: string;
  imgName: string;
}

/** コンテンツ情報 */
interface ContentsDataModel {
  categoryId: string;
  categoryName: string;
  subCategoryId: string;
  subCategoryName: string;
  contentsId: string;
  title: string;
  keisaiKikanStart: string;
  keisaiKikanEnd: string;
  newFlg: boolean;
  jyuyoFlg: boolean;
  lastUpdate: string;
  contentsBody: string;
  contentsLinkList: ContentsLinkListModel[];
  contentsVideoList: ContentsVideoListModel[];
  contentsTempFileList: ContentsTempFileListModel[];
  contentsImgList: ContentsImgListModel[];
  isFavorite: boolean;
  detailPath: string;
  updateFormPath: string;
}

export default defineComponent({
  name: "ToranomakiComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    Carousel,
    Slide,
    Pagination,
    Navigation,
    VideoPlayer,
    LoadingOverlay,
  },
  setup() {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { getCategoryIdByName } = useUserParmitionStore();
    const skilupKouseiData = ref<SkilupKouseiItem>(); // スキルアップ構成データ
    const activeStepName = ref(""); // アクティブなステップ名を保持するための変数
    const activePhaseId = ref(""); // アクティブなフェーズIDを保持するための変数
    const activePhaseName = ref(""); // アクティブなフェーズ名を保持するための変数
    const activeChapter = ref<PhaseKouseiModel | null>(null);
    const errorMessage = ref(""); // エラーメッセージ
    const sanitizedContent = ref(""); //サニタイジングされた本文
    const itemsToShow = ref(1.0);
    const isModalOpen = ref(false);
    const selectedVideo = ref<ContentsVideoListModel | null>(null);
    const categoryId = ref("");
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const isDataFetched = ref(false); // 構成データが取得済みかどうかを追跡
    const iContentsDataFetched = ref(false); // コンテンツデータが取得済みかどうかを追跡
    const defaultDispCnt = ref(3);
    const { logoutUser } = useUserStore();
    const isLoading = ref(false);

    /**
     * コンテンツデータの定義
     */
    const contentsData = ref<ContentsDataModel>({
      categoryId: "",
      categoryName: "",
      subCategoryId: "",
      subCategoryName: "",
      contentsId: "",
      title: "",
      keisaiKikanStart: "",
      keisaiKikanEnd: "",
      newFlg: false,
      jyuyoFlg: false,
      lastUpdate: "",
      contentsBody: "",
      contentsLinkList: [],
      contentsVideoList: [],
      contentsTempFileList: [],
      contentsImgList: [],
      isFavorite: false,
      detailPath: "",
      updateFormPath: "",
    });

    // 初期状態のオブジェクト
    const initialContentsData: ContentsDataModel = {
      categoryId: "",
      categoryName: "",
      subCategoryId: "",
      subCategoryName: "",
      contentsId: "",
      title: "",
      keisaiKikanStart: "",
      keisaiKikanEnd: "",
      newFlg: false,
      jyuyoFlg: false,
      lastUpdate: "",
      contentsBody: "",
      contentsLinkList: [],
      contentsVideoList: [],
      contentsTempFileList: [],
      contentsImgList: [],
      isFavorite: false,
      detailPath: "",
      updateFormPath: "",
    };

    /**
     * 初期処理
     */
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);

        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // 虎の巻のカテゴリIDを取得
        categoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_TORANOMAKI
        ) as string;

        // 虎の巻構成データ取得API
        const response = await apiAuthClient.post("/api/SkilUp/getToranomaki", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: serchUserId.value,
          agCode: serchAgCode.value,
          categoryId: categoryId.value,
        });

        // レスポンスから虎の巻構成データを取得
        const data = response.data;
        skilupKouseiData.value = data;

        if (skilupKouseiData.value) {
          defaultDispCnt.value = skilupKouseiData.value.dispCount;
          outputDebugLogs("defaultDispCnt:" + defaultDispCnt.value);
        }

        isDataFetched.value = true; // 構成データが取得されたことを設定
        isInitError.value = false;
      } catch (error: unknown) {
        isInitError.value = true;
        // エラー時は初期表示エラーフラグをON
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * 各フェーズのisOpenをトグルする関数
     * @param phase フェーズリスト
     */
    const togglePhaseOpen = (phase: SkilupPhaseListItem) => {
      phase.isOpen = !phase.isOpen;
    };

    /**
     * phaseKouseiListの表示数を制御する関数
     * @param phaseKouseiList
     * @param isOpen
     */
    const getDisplayedChapters = (
      phaseKouseiList: PhaseKouseiModel[],
      isOpen: boolean
    ) => {
      return isOpen
        ? phaseKouseiList
        : phaseKouseiList.slice(0, defaultDispCnt.value);
    };

    /**
     * 選択したチャプターのコンテンツを取得する
     * @param chapterId チャプターID
     */
    const showActiveChapter = async (
      phase: SkilupPhaseListItem,
      chapter: PhaseKouseiModel,
      stepName: string
    ) => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      iContentsDataFetched.value = false;
      isLoading.value = true;
      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }
        contentsData.value = { ...initialContentsData };
        errorMessage.value = "";
        activePhaseId.value = phase.phaseId;
        activePhaseName.value = phase.phaseName;
        activeStepName.value = stepName;
        activeChapter.value = chapter;

        // コンテンツ詳細取得API
        const response = await apiAuthClient.post(
          "/api/ContentsDetail/getContentsDetail",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: chapter.chapterCategoryId,
            contentId: chapter.chapterContentsId,
            targetDate: getTargetDate(""),
          }
        );

        // レスポンスからコンテンツ詳細データを取得
        const data = response.data;
        contentsData.value = data;

        // 本文をサニタイジングする
        sanitizedContent.value = sanitizeInput(contentsData.value.contentsBody);

        // サムネイルを生成
        generateThumbnails();

        iContentsDataFetched.value = true;
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 403:
              // 参照権限なし（コンテンツが存在しない場合もここ）
              errorMessage.value = messages.ERR_0022;
              break;
            default:
              // その他のエラー
              errorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          errorMessage.value = messages.ERR_SYS001;
        } else {
          errorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }

        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * 受講済のチェック画像を返す関数
     * @param activePhaseId
     * @param activeChapterId
     * @param currentPhaseId
     * @param currentChapterId
     * @param isWatched
     */
    const getCheckeImg = (
      activePhaseId: string,
      activeChapterId: string,
      currentPhaseId: string,
      currentChapterId: string,
      isWatched: boolean
    ) => {
      if (isWatched == true) {
        if (
          activePhaseId == currentPhaseId &&
          activeChapterId == currentChapterId
        ) {
          return IconCheck1w;
        } else {
          return IconCheck1gr;
        }
      } else {
        if (
          activePhaseId == currentPhaseId &&
          activeChapterId == currentChapterId
        ) {
          return IconCheck1gr;
        } else {
          return IconCheck1g;
        }
      }
    };

    /**
     * 各フェーズのisWatchedがtrueの件数を計算する関数
     * @param phase
     */
    const getWatchedCount = (phase: SkilupPhaseListItem) => {
      return phase.phaseKouseiList.filter((chapter) => chapter.isWatched)
        .length;
    };

    /**
     * サムネイル生成
     * 動画ファイルからサムネイル画像を生成します
     */
    const generateThumbnails = async () => {
      for (const video of contentsData.value.contentsVideoList) {
        if (!video.videoName) continue;

        const videoElement = document.createElement("video");

        outputDebugLogs("video.videoPath: " + video.videoPath);
        outputDebugLogs("video.videoName: " + video.videoName);

        videoElement.src = video.videoPath + "/" + video.videoName;
        videoElement.src = videoElement.src.replace(
          process.env.VUE_APP_ADDROOT_PATH,
          ""
        );

        outputDebugLogs("videoElement.src: " + videoElement.src);

        await new Promise((resolve) => {
          videoElement.onloadeddata = resolve;
        });

        // Set time to capture a frame (e.g., 1 second)
        videoElement.currentTime = 1;

        await new Promise((resolve) => {
          videoElement.onseeked = resolve;
        });

        // Create a canvas to capture the frame
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const context = canvas.getContext("2d");
        context?.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

        // Convert canvas to data URL for the thumbnail
        video.thumbnail = canvas.toDataURL("image/jpeg");
      }
    };

    /**
     * Videoモーダル表示
     */
    const openModal = (video: ContentsVideoListModel) => {
      selectedVideo.value = video;
      isModalOpen.value = true;
    };

    /**
     * VideoモーダルClose
     */
    const closeModal = () => {
      isModalOpen.value = false;
    };

    /**
     * 視聴完了制御
     */
    const updateWatchedStatus = async (chapter: PhaseKouseiModel) => {
      // なにか処理中の場合は何もしない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        chapter.isWatched = !chapter.isWatched;
        console.log("Updated isWatched:", chapter.isWatched);

        // スキルアップ視聴履歴登録・削除API
        const response = await apiAuthClient.post(
          "/api/SkilUp/skilupWatchHistoryReg",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: activeChapter.value?.chapterCategoryId,
            contentsId: activeChapter.value?.chapterContentsId,
            isWatched: activeChapter.value?.isWatched,
          }
        );

        console.log("skilupWatchHistoryReg:", response.status);
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
      scrollToTop();
    };

    /**
     * リンククリックのログを出力します
     * @param linkUrl リンクURL
     */
    const regLinkClick = (linkUrl: string) => {
      regLinkClickLog(
        linkUrl,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        contentsData.value.contentsId,
        "虎の巻"
      );
    };

    /**
     * ファイルリンククリックのログを出力します
     * @param fileName ファイル名
     */
    const regFileLinkClick = (fileName: string) => {
      regFileLinkClickLog(
        fileName,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        contentsData.value.contentsId,
        "虎の巻"
      );
    };

    /**
     * ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const downloadFiles = async (
      ctgyId: string,
      ctsId: string,
      flName: string
    ) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post("/api/download", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: userId.value,
          agCode: agCode.value,
          categoryId: ctgyId,
          contentId: ctsId,
          fileName: flName,
          targetDate: getTargetDate(""),
          pseudoUserId: pseudoUserId.value,
          pseudoAgCode: pseudoAgCode.value,
          screenName: "虎の巻",
        });

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 掲載期間内チェック
     */
    const isWithinKeisaiKikan = computed(() => {
      const today = new Date(getTargetDate("")); // 現在の日付
      const start = contentsData.value.keisaiKikanStart
        ? new Date(contentsData.value.keisaiKikanStart)
        : null;
      const end = contentsData.value.keisaiKikanEnd
        ? new Date(contentsData.value.keisaiKikanEnd)
        : null;

      // `start` または `end` が無効な場合は false を返す
      if (!start || isNaN(start.getTime())) return false;
      if (!end || isNaN(end.getTime())) return false;

      // 現在日付が期間内にあるかを判定
      return today >= start && today <= end;
    });

    return {
      isInitError,
      skilupKouseiData,
      getDisplayedChapters,
      togglePhaseOpen,
      showActiveChapter,
      activeChapter,
      activeStepName,
      activePhaseId,
      activePhaseName,
      errorMessage,
      contentsData,
      sanitizedContent,
      getCheckeImg,
      getWatchedCount,
      itemsToShow,
      isDataFetched,
      iContentsDataFetched,
      openModal,
      closeModal,
      isModalOpen,
      selectedVideo,
      defaultDispCnt,
      updateWatchedStatus,
      regLinkClick,
      regFileLinkClick,
      downloadFiles,
      isWithinKeisaiKikan,
      isLoading,
    };
  },
});
</script>

<style scoped>
.carousel-thumbnail {
  width: 100%;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.modal-content {
  position: relative;
  background: white;
  padding: 20px;
  max-width: 60%;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* モーダルに軽い影をつけて見やすく */
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
</style>
